var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"highlight"},[_c('h1',[_vm._v(_vm._s(_vm.statistic.label))]),_c('div',{staticClass:"count"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.statistic.value)),(_vm.statistic.unit)?_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.statistic.unit))]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }